module.exports = __webpack_public_path__ + "assets/img/09a.4c7df010.jpg";